import React from "react";
import { Container, Row, Col, Table, Image } from "react-bootstrap";

import { useEffect, useState } from "react";
import axios from "axios";
import { Form, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../Components/Loader";
import Message from "../../Components/Message";
import apiClient from "../../AppClient";

function StaffProfileScreen() {
    const [userData, setUserData] = useState({
        id: 63,
        first_name: "first_name",
        last_name: "last_name",
        name: "name",
        username: "username",
        email: "email@gmail.com",
        phone: "0000000",
        is_staff: true,
        role: {},
        is_activated: false,
        image: "/media/profile_placeholder.png"
    });
    const navigate = useNavigate();

    useEffect(() => {
        fetchUser();
    }, []);


    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const fetchUser = async () => {
        setLoading(true);
        apiClient.get(`/staff/profile/`)
          .then(response => 
            setUserData({
              id: response.data.id,
              first_name: response.data.first_name,
              last_name: response.data.last_name,
              name: response.data.name,
              username: response.data.username,
              email: response.data.email,
              phone: response.data.phone,
              is_staff: response.data.is_staff,
              role: response.data.role,
              is_activated: response.data.is_activated,
              image: response.data.image
            })
          )
          .catch(error => setError(error.response.data.detail));
        setLoading(false);
      }
      const { name, username, email ,role ,phone, image } = userData;
    return (
        <div className='w-100 '>
            {loading ? <Loader /> : error ? <Message variant='danger'>{error}</Message> :

                <div className="mt-3 w-100 text-center">
                    <Row className="justify-content-md-center">
                        <Col md={8} className="text-center">
                            {/* Profile Picture */}
                            <Image
                                src={`${process.env.REACT_APP_API_URL}${image}`}
                                roundedCircle
                                width={150}
                                height={150}
                            />
                            <h2 className="mt-3">{name}</h2>
                            <p className="text-muted">{role?.name}</p>
                        </Col>
                    </Row>
                    <div className="text-start mt-3">
                        <Row className="justify-content-md-center my-3">
                            <Col md={3} className="font-weight-bold">الاسم</Col>
                            <Col md={3} className="border border-primary rounded p-2 bg-light text-dark">{name}</Col>
                        </Row>
                        <Row className="justify-content-md-center my-3">
                            <Col md={3} className="font-weight-bold">اسم المستخدم</Col>
                            <Col md={3} className="border border-primary rounded p-2 bg-light text-dark">{username}</Col>
                        </Row>
                        <Row className="justify-content-md-center my-3">
                            <Col md={3} className="font-weight-bold">البريد الاليكتروني</Col>
                            <Col md={3} className="border border-primary rounded p-2 bg-light text-dark">{email}</Col>
                        </Row>
                        <Row className="justify-content-md-center my-3">
                            <Col md={3} className="font-weight-bold">الهاتف</Col>
                            <Col md={3} className="border border-primary rounded p-2 bg-light text-dark">{phone}</Col>
                        </Row>

                    </div>
                    
                </div>
            }




        </div>
    )
}
export default StaffProfileScreen;
